import { createHashRouter } from 'react-router-dom';
import EstimatorView from './individual/views/EstimatorView/EstimatorView';
import { TechnicalError } from './individual/views/TechnicalError';

const getEstimatorRouter = () =>
  createHashRouter([
    {
      path: '/',
      element: <EstimatorView />,
      errorElement: <TechnicalError />,
    },
  ]);

export default getEstimatorRouter;
